import React, {useState} from 'react'
import {Link} from 'gatsby'

import Layout from '../components/layouts/layout'
import SocialProofSection from '../components/social-proof-section'

import featureStyles from '../components/pricing-features-table.module.scss'
import {bool, combine} from '../styles/classname-utils'
import PricingFaqSection from '../components/pricing-faq-section'
import PricingAdsSection from '../components/ads/pricing-ads-section'
import PricingPlanTable from '../components/pricing-plan-table'
import PricingFeaturesTable from '../components/pricing-features-table'
import Button8 from '../components/button8'
import LicensePricingCards from '../components/pricing-license-cards'
import {brandBlack} from '../styles/brand-colors'
import PricingToggle from '../components/pricing-toggle'

export default () => {
  const [showFeaturesTable, setShowFeaturesTable] = useState(false)
  const [stickyFeaturesTable, setStickyFeaturesTable] = useState(false)
  const [showAnnualPricing, setShowAnnualPricing] = useState(true)

  return (
    <Layout
      title='Pricing and Plans - WebAR, AR, WebVR Developer Tools and SDK'
      description='Compare plans and get started with a 14-day free trial of 8th Wall so you and
        your team can create, collaborate and publish extraordinary WebAR content.'
    >
      <section className='light'>
        <div className='row m-0 justify-content-center' id='pricing-container'>
          <div className='col-12 col-md-9 col-lg-12 max-width text-center'>
            <h2>Find the right plan to start developing</h2>
          </div>
        </div>
        <PricingToggle
          showAnnualPricing={showAnnualPricing}
          setShowAnnualPricing={() => { setShowAnnualPricing(!showAnnualPricing) }}
        />
        <PricingPlanTable showAnnualPricing={showAnnualPricing} />
        <div className='row mt-4 justify-content-center'>
          <Button8
            className={featureStyles.collapseButton}
            secondary
            data-toggle='collapse'
            data-target='#collapseFeaturesTable'
            aria-expanded='false'
            aria-controls='collapseFeaturesTable'
            onClick={() => {
              setShowFeaturesTable(!showFeaturesTable)
              if (stickyFeaturesTable) {
                setStickyFeaturesTable(false)
              } else {
                setTimeout(() => setStickyFeaturesTable(true), 500)
              }
            }}
            a8={showFeaturesTable ? 'click;pricing;hide-view-all-features'
              : 'click;pricing;expand-view-all-features'}
          >
            {showFeaturesTable
              ? <i className='fas fa-minus' />
              : <i className='fas fa-plus' />
            }
            <span className='ml-2'>{showFeaturesTable ? 'Hide' : 'View'}&nbsp;All Features</span>
          </Button8>
        </div>
        <div className='collapse' id='collapseFeaturesTable'>
          <div className={combine(bool(stickyFeaturesTable, 'sticky-top'),
            featureStyles.stickyBlock)}
          />
          <PricingFeaturesTable showFeaturesTable={showFeaturesTable} />
        </div>
      </section>

      <section>
        <div className='row m-0 justify-content-center'>
          <div className='col-12 col-md-10 col-lg-8 col-xl-9 px-0 text-center'>
            <h2 style={{scrollMarginTop: '5em'}} id='commercial-license'>
              Commercial Licenses for Brands and Organizations
            </h2>
            <p className='noto-sans-jp text8-lg font8-medium mb-5'>
              Brands and organizations require commercial licenses or an Enterprise
              plan for public use of 8th Wall projects. Agencies and studios on the
              Pro plan may purchase a per-project commercial licenses on behalf of
              their clients.
            </p>
          </div>
        </div>
        <div className='row m-0 justify-content-center'>
          <LicensePricingCards />
        </div>
        <div className='row m-0 justify-content-center'>
          <div className='col-12 col-md-10 col-lg-8 col-xl-12 px-0'>
            <p className='text-center font8-medium text8-lg noto-sans-jp'>
              Unlimited views are subject to certain{' '}
              <Link
                style={{
                  fontWeight: 700,
                  color: brandBlack,
                }}
                to='/pricing#faq'
              >
                restrictions
              </Link>.{' '}
              <Link
                to='/licensing'
                a8='click;purchase-intent;contact-licensing'
              >
                Contact&nbsp;sales
              </Link>{' '}
              for annual licenses and enterprise plans.{' '}
              <br />
              All commercial projects must display the{' '}
              <Link
                to='https://drive.google.com/drive/folders/1c9d23c5hS_HspHTUD7VceV6ocqdbPN7J?usp=sharing'
                a8='click;explore;download-powered-by-8thwall'
                target='_blank'
                rel='noopener noreferrer'
                style={{
                  fontWeight: 700,
                  color: brandBlack,
                }}
              >
                Powered&nbsp;by&nbsp;8th&nbsp;Wall&nbsp;badge
              </Link>
              {' '}on the loading page.
            </p>
          </div>
        </div>
        <div className='row m-0 justify-content-center'>
          <div className='col-12 col-md-8 col-lg-8 px-0 max-width'>
            <p className='text-center font8-regular text8-sm noto-sans-jp'>
              *Depending on where you live, you may be charged taxes in
              addition to the prices displayed.
            </p>
          </div>
        </div>
      </section>

      <PricingAdsSection />

      <SocialProofSection a8='click;click-free-trial-cta;social-proof-cta' />

      <PricingFaqSection id='faq-section' />
    </Layout>
  )
}
